import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  /** Красная кнопка подтверждения — для удалений и прочего необратимого. */
  danger?: boolean;
  /**
   * Слово, которое админ обязан напечатать, прежде чем кнопка оживёт — для действий,
   * которые нельзя отменить и которые задевают всех игроков сразу.
   */
  requireText?: string;
}

interface Pending extends ConfirmOptions {
  resolve: (ok: boolean) => void;
}

export const useConfirmStore = defineStore('confirm', () => {
  const current = ref<Pending | null>(null);

  function ask(opts: ConfirmOptions | string): Promise<boolean> {
    const o = typeof opts === 'string' ? { message: opts } : opts;
    // Предыдущий незакрытый диалог считаем отменённым.
    current.value?.resolve(false);
    return new Promise<boolean>((resolve) => {
      current.value = { ...o, resolve };
    });
  }

  function close(ok: boolean) {
    const c = current.value;
    current.value = null;
    c?.resolve(ok);
  }

  return { current, ask, close };
});

/**
 * Замена window.confirm(): `if (!(await confirmDialog({ message, danger: true }))) return;`
 * Строку можно передать сразу: `await confirmDialog('Delete?')`. Слова «delete/remove/wipe/ban»
 * в тексте сами делают кнопку красной, если danger не задан явно.
 */
export function confirmDialog(opts: ConfirmOptions | string): Promise<boolean> {
  const o = typeof opts === 'string' ? { message: opts } : { ...opts };
  if (o.danger === undefined) o.danger = /\b(delete|remove|wipe|ban|kick|reset|drop|revoke)\b/i.test(o.message);
  return useConfirmStore().ask(o);
}
